import { ControlPhotoFragmentFragment } from 'data/__generated__';

const isStartPhoto = (photo: ControlPhotoFragmentFragment): boolean => photo.type.includes('Start');

const getBaseType = (type: string): string => type.replace('Start', '');

const TYPES_WITH_START_PAIR = [
    'ColumnPhoto',
    'ColumnOpenDoorPhoto',
    'ColumnClosedDoorPhoto',
    'HotDrinksTanks',
    'HotDrinksStocks',
];

const hasStartPair = (type: string): boolean => TYPES_WITH_START_PAIR.includes(getBaseType(type));

const getPhotoCategory = (type: string): number => {
    if (type.includes('Column')) return 1;
    if (type.includes('HotDrinks')) return 2;
    return 3;
};

const sortPhotos = (photos: ControlPhotoFragmentFragment[]): ControlPhotoFragmentFragment[] => {
    return [...photos].sort((a, b) => {
        // 1. Sort by category
        const categoryDiff = getPhotoCategory(a.type) - getPhotoCategory(b.type);
        if (categoryDiff !== 0) return categoryDiff;

        // 2. Sort by photos with matching pair
        if (hasStartPair(a.type) !== hasStartPair(b.type)) {
            return hasStartPair(a.type) ? -1 : 1;
        }

        // 3. Sort by machineName
        const machineCompare = (a.microstoreColumn?.name ?? '').localeCompare(b.microstoreColumn?.name ?? '');
        if (machineCompare !== 0) return machineCompare;

        // 4. Sort by base type
        const typeCompare = getBaseType(a.type).localeCompare(getBaseType(b.type));
        if (typeCompare !== 0) return typeCompare;

        // 5. Sort by photoIndex
        return a.photoIndex - b.photoIndex;
    });
};

export const separatePhotosByStartEnd = (
    photos: ControlPhotoFragmentFragment[],
): { startPhotos: ControlPhotoFragmentFragment[]; endPhotos: ControlPhotoFragmentFragment[] } => {
    const startPhotos = sortPhotos(photos.filter(isStartPhoto));
    const endPhotos = sortPhotos(photos.filter((photo) => !isStartPhoto(photo)));
    return { startPhotos, endPhotos };
};
